// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f4ff013d","453":"37753ddd"}[chunkId] + ".chunk.js";
};